{
  "close": "Chiudi"
}
